/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { useHistory, matchPath } from 'react-router';
import { BrandColors, MaterialIcon } from '@blend/enterprise-components';
import { fonts } from '@blend/consumer-components';

export namespace NavLinkButton {
  export interface Props {
    display: string;
    iconType: any;
    route: string;
  }
}

const styles = StyleSheet.create({
  buttonWrapper: {
    border: 'none',
    background: 'none',
    boxShadow: 'none',
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    padding: '8px 16px',
    textTransform: 'uppercase',
    margin: '0px auto',
    width: 228,
    ...fonts.UntitledSans,
  },
  displayWrapper: {
    color: BrandColors.WHITE,
    fontSize: 14,
    marginLeft: 18,
  },
  selectedButton: {
    backgroundColor: BrandColors.NIGHT_60,
    borderRadius: 20,
  },
});

export const NavLinkButton: React.FC<NavLinkButton.Props> = ({ iconType, display, route }) => {
  const history = useHistory();
  const isActive = matchPath(location.pathname, route);
  const handleOnClick = () => {
    // when route is absolute URL (ex: Link 'Notaries') points to Bridge with absolute URL
    if (route.startsWith('http')) {
      window.location.href = route;
    } else {
      history.push(route);
    }
  };

  return (
    <button
      className={css(styles.buttonWrapper, isActive && styles.selectedButton)}
      data-it={`NavLinkButton-${display}`}
      onClick={handleOnClick}
    >
      {iconType && <MaterialIcon color={BrandColors.WHITE} size={22} type={iconType} />}
      <span className={css(styles.displayWrapper)}>{display}</span>
    </button>
  );
};
